<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO GUARDAR ROL  -->
  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">

        <div class="form-group col-md-6">
          <!--          <app-lfsa-input [control]="formulario.get('cedula') | formControl" [id]="'cedula'"
                                    [label]="'Cedula*'"
                                    [mostrarImg]="false" [placeholder]="'cedula'" [rutaImagen]="" [type]="'text'"
                                    formControlName="cedula">
                    </app-lfsa-input>-->
          <label>Empleado* {{ '  ' + labelEmpleadoInfo ? labelEmpleadoInfo : ''}}</label>
          <button (click)="openModalEmpleados()"
                  [disabled]="editableForm"
                  class="btn btn-primary btn-block"
          >
            <i class="fa fa-users"></i>
          </button>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('horas') | formControl" [id]="'hora'"
                          [label]="'Hora*'" [mostrarImg]="false" [placeholder]="'Hora'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="horas">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbTipos" [control]="formulario.get('tipoCalculo') | formControl"
                              [idOpcion]="'id'"
                              [id]="'tipoCalculo'" [label]=" 'Tipo de Calculo*'"
                              [opcion]="'descripcion'"
                              formControlName="tipoCalculo">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbTipoTurno" [control]="formulario.get('idTurno') | formControl"
                              [idOpcion]="'id'"
                              [id]="'tipoCalculo'" [label]=" 'Tipo de turno'"
                              [opcion]="'id'"
                              formControlName="idTurno">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-6 mb-3">
          <div class="form-check">
            <input [(ngModel)]="poseeHS" class="form-check-input" formControlName="poseeHS"
                   id="poseeHS" type="checkbox">
            <label class="form-check-label" for="poseeHS">
              Aplica HS
            </label>
          </div>
        </div>
        <div class="form-group col-md-6 mb-3">
          <div class="form-check">
            <input [(ngModel)]="poseeHE" class="form-check-input" formControlName="poseeHE"
                   id="poseeHE" type="checkbox">
            <label class="form-check-label" for="poseeHE">
              Aplica HE
            </label>
          </div>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista" [innTemplateButton]="innTemplateButtonAddRol"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonAddRol>
    <div class="col-md-6">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <a (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregarEmpleado}}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #enviarTemplate>
    <section class="section">
      <div class="row">
        <div class="row mb-4">
          <div class="form-group col-md-6">
            <label for="excelInput">Cargar Excel</label>
            <input #fileInput (change)="onFileSelect($event)" accept=".xlsx" class="form-control-file" id="excelInput"
                   type="file"/>
          </div>
          <div class="form-group col-md-6">
            <button (click)="descargarExcel()" class="btn btn-success btn-block">Descargar Excel</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!loading" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>


<app-modal-empleado></app-modal-empleado>
